// extracted by mini-css-extract-plugin
module.exports = {"container":"SkillCard_container__1ojEI","technology":"SkillCard_technology__2nxpf"};